import React from "react";
import PersonForm, { baseFields, passwordFields } from "./PersonForm";
import PersonView from "./PersonView";
import PersonChangePassword from "./PersonChangePassword";

/**
 * Configured personnel screens (Driver / Fleet Manager / Transport Manager /
 * Vehicle Assistant / Delivery Person) mirroring the production add/edit/view/
 * change-password pages. Built on the reusable PersonForm/PersonView components.
 */

const driverExtra = [
  { label: "Licence Number", placeholder: "Enter Your Licence Number" },
  { label: "Licence Area", placeholder: "Enter Your Licence Area" },
  { label: "Mifarecard ID", placeholder: "Enter Your Mifarecard ID" },
];
const assistantExtra = [{ label: "Mifarecard Id", placeholder: "Enter Your Mifarecard Id" }];

// ---- sample view data ----
const personalCard = (name) => ({
  heading: "Personal Information",
  rows: [
    { label: "Name", value: name },
    { label: "Contact Number", value: "99999 99999" },
    { label: "Email", value: "markwoods@gmail.com", full: true },
    { label: "Internal No.", value: "123456" },
  ],
});
const generalCard = (extraRows = []) => ({
  heading: "General Information",
  rows: [
    { label: "Address", value: "100, Vishrantwadi, Kalas, Pune- 411005", full: true },
    { label: "City", value: "Pune" },
    { label: "Nationality", value: "India" },
    { label: "Date Of Birth", value: "17-08-1989" },
    { label: "Joining Date", value: "08-10-2022" },
    { label: "Gender", value: "Male" },
    ...extraRows,
  ],
});

// ---------- Drivers ----------
export const AddDriver = () => (
  <PersonForm title="Add Driver" fields={[...baseFields, ...driverExtra, ...passwordFields]} />
);
export const EditDriver = () => (
  <PersonForm title="Edit Driver" fields={[...baseFields, ...driverExtra]} submitLabel="Update" />
);
export const ViewDriver = () => (
  <PersonView
    title="Driver Details"
    cards={[
      personalCard("Mark Woods"),
      generalCard([
        { label: "Licence Number", value: "DL-0420110149646" },
        { label: "Licence Area", value: "Pune" },
        { label: "Mifarecard ID", value: "MFC-12345" },
      ]),
    ]}
  />
);
export const ChangeDriverPassword = () => <PersonChangePassword title="Change Driver Password" />;

// ---------- Fleet Manager ----------
export const AddFleetManager = () => (
  <PersonForm title="Add Fleet Manager" fields={[...baseFields, ...passwordFields]} />
);
export const EditFleetManager = () => (
  <PersonForm title="Edit Fleet Manager" fields={baseFields} submitLabel="Update" />
);
export const ViewFleetManager = () => (
  <PersonView title="Fleet Manager Details" cards={[personalCard("Mark Woods"), generalCard()]} />
);
export const ChangeFleetPass = () => <PersonChangePassword title="Change Fleet Manager Password" />;

// ---------- Transport Manager ----------
export const AddTransportManager = () => (
  <PersonForm title="Add Transport Manager" fields={[...baseFields, ...passwordFields]} />
);
export const EditTransportManager = () => (
  <PersonForm title="Edit Transport Manager" fields={baseFields} submitLabel="Update" />
);
export const ViewTransportManager = () => (
  <PersonView title="Transport Manager Details" cards={[personalCard("Mark Woods"), generalCard()]} />
);
export const ChangeTransportPassword = () => (
  <PersonChangePassword title="Change Transport Manager Password" />
);

// ---------- Vehicle Assistant ----------
export const AddVehicleAssistant = () => (
  <PersonForm
    title="Add Vehicle Assistant"
    fields={[...baseFields, ...assistantExtra, ...passwordFields]}
  />
);
export const EditVehicleAssistant = () => (
  <PersonForm
    title="Edit Vehicle Assistant"
    fields={[...baseFields, ...assistantExtra]}
    submitLabel="Update"
  />
);
export const ViewVehicleAssistant = () => (
  <PersonView
    title="Vehicle Assistant Details"
    cards={[personalCard("Mark Woods"), generalCard([{ label: "Mifarecard Id", value: "MFC-12345" }])]}
  />
);
export const ChangeVehicleAssistantPassword = () => (
  <PersonChangePassword title="Change Vehicle Assistant Password" />
);

// ---------- Delivery Person (Add already built separately) ----------
export const EditDeliveryPerson = () => (
  <PersonForm title="Edit Delivery Person" fields={baseFields} submitLabel="Update" />
);
export const ViewDeliveryPerson = () => (
  <PersonView title="Delivery Person Details" cards={[personalCard("Mark Woods"), generalCard()]} />
);
export const ChangeDeliveryPassword = () => (
  <PersonChangePassword title="Change Delivery Person Password" />
);
